import axios from "axios";
import { loginreq, req, reqGet } from "./axiosFun";

// 登录接口
export const login = params => {
  return loginreq("post", "/app-yijiu-backstage/login", params);
};

// 获取用户菜单
export const menu = params => {
  return axios
    .get("/api/menu?&token=" + localStorage.getItem("logintoken"))
    .then(res => res.data);
};
// 退出接口
export const loginout = () => {
  return axios
    .delete("/api/login?&token=" + localStorage.getItem("logintoken"))
    .then(res => res.data);
};

//用户管理
// 获取用户列表
export const getAdminUserList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAdminUserList", params);
};

//用户管理
// 查询承诺书
export const getCommitmentRecord = params => {
  return reqGet("get", "/app-yijiu-backstage/getCommitmentRecord", params);
};

//用户管理
// 拉黑用户
export const getBlackoutUsers = params => {
  return reqGet("get", "/app-yijiu-backstage/setUserState", params);
};
//用户管理
// 解除拉黑
export const getBlackoutUsersJ = params => {
  return reqGet("get", "/app-yijiu-backstage/setUserStateJ", params);
};








//用户管理
// 获取用户列表
export const setUserPayouts = params => {
  return reqGet("get", "/app-yijiu-backstage/setUserPayouts", params);
};

// 获取用户分佣列表
export const getDistributorList = params => {
  return req("post", "/app-yijiu-backstage/getUserCommissionsList", params);
};
// 审核注册用户
export const aduitUser = params => {
  return req("post", "/app-yijiu-backstage/aduitUser", params);
};
// 禁用/启用用户
export const updateUserStatus = params => {
  return req("post", "/app-yijiu-backstage/updateUserStatus", params);
};
// 商家主页商品列表
export const UserGoodsList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAdminMerchantGameGoodsList", params);
};
// 查询用户评论列表
export const userCommentsList = params => {
  return reqGet("get", "/app-yijiu-backstage/getUserCommodityReplyList", params);
};
// 查询用户商品评论列表
export const userBeCommentedOnList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAdminCommodityReplyLists", params);
};

//分类管理
export const getCategoryList = params => {
  return req("post", "/app-yijiu-backstage/getCategoryList", params);
};
export const addCategory = params => {
  return req("post", "/app-yijiu-backstage/addCategory", params);
};
export const upCategory = params => {
  return req("post", "/app-yijiu-backstage/upCategory", params);
};
export const deleteCategory = params => {
  return req("post", "/app-yijiu-backstage/deleteCategory", params);
};

//上传前端
export const getCarouselList = params => {
  return reqGet("get", "/app-yijiu-backstage/getCarouselList", params);
};
export const addSlideshow = params => {
  return req("post", "/app-yijiu-backstage/addCarousel", params);
};
export const upSlideshow = params => {
  return req("post", "/app-yijiu-backstage/upCarousel", params);
};
export const deleteSlideshow = params => {
  return req("post", "/app-yijiu-backstage/deleteCarousel", params);
};

// 商品管理
// 查看商品列表
export const getCommodityList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getCommodityList?token=${localStorage.getItem(
        "logintoken"
      )}&name=${params.name}&entity=${params.entity}&isDisable=${params.isDisable
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查看商品详情
export const getCommodityInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getCommodityInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加商品
export const addCommodity = params => {
  return req("post", "/app-yijiu-backstage/addCommodity", params);
};
// 删除商品
export const deleteCommodity = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteCommodity?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改商品
export const upCommodity = params => {
  return req("post", "/app-yijiu-backstage/upCommodity", params);
};
// 调整商品库存
export const alterCommodityCount = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/alterCommodityCount?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}&type=${params.type}&count=${params.count}`,
      params
    )
    .then(res => res.data);
};

// 评价管理
// 查询所有作品评论
export const getPublishReplyList = params => {
  return req("post", "/app-yijiu-backstage/getPublishReplyList", params);
};
// 删除作品评论
export const deletePublishReplyList = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deletePublishReplyList?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};

// 作品管理
// 查询所有作品
export const getPublishList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getPublishList?token=${localStorage.getItem(
        "logintoken"
      )}&type=${params.type}&status=${params.status}&page=${params.page
      }&title=${params.title}`,
      params
    )
    .then(res => res.data);
};
// 审核通过
export const aduitAccessPublish = params => {
  return req("post", "/app-yijiu-backstage/aduitAccessPublish", params);
};
// 审核不通过
export const aduitNoAccessPublish = params => {
  return req("post", "/app-yijiu-backstage/aduitNoAccessPublish", params);
};
// 设置作品排序
export const setSort = params => {
  return req("post", "/app-yijiu-backstage/setSort", params);
};

// 活动管理
// 添加活动
export const addActivity = params => {
  return req("post", "/app-yijiu-backstage/addActivity", params);
};
// 删除活动
export const deleteActivity = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteActivity?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 查询活动详情
export const getActivityInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getActivityInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 查询活动列表
export const getActivityList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getActivityList?token=${localStorage.getItem(
        "logintoken"
      )}&status=${params.status}&title=${params.title}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查询活动报名用户列表
export const getActivityUserInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getActivityUserInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 修改活动
export const upActivity = params => {
  return req("post", "/app-yijiu-backstage/upActivity", params);
};

// 用户反馈
export const responseFeedback = params => {
  return req("post", "/app-yijiu-backstage/responseFeedback", params);
};

export const getFeedback = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getFeedback?token=${localStorage.getItem(
        "logintoken"
      )}&keyword=${params.keyword}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};

// 发布分类管理
// 添加发布
export const addPublishCategory = params => {
  return req("post", "/app-yijiu-backstage/addPublishCategory", params);
};
// 删除发布
export const deletePublishCategory = params => {
  return req("post", "/app-yijiu-backstage/deletePublishCategory", params);
};
// 查询发布
export const getPublishCategorysList = params => {
  return req("post", "/app-yijiu-backstage/getPublishCategoryList", params);
};
// 修改发布
export const upPublishCategory = params => {
  return req("post", "/app-yijiu-backstage/upPublishCategory", params);
};

// 放映厅管理
// 查询放映厅列表
export const getScreenRoomList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getScreenRoomList?token=${localStorage.getItem(
        "logintoken"
      )}&name=${params.name}&categoryName=${params.categoryName}&page=${params.page
      }`,
      params
    )
    .then(res => res.data);
};
// 查询放映厅详情
export const getScreenRoomInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getScreenRoomInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加放映厅
export const addScreenRoom = params => {
  return req("post", "/app-yijiu-backstage/addScreenRoom", params);
};
// 删除放映厅
export const deleteScreenRoom = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteScreenRoom?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改放映厅
export const upScreenRoom = params => {
  return req("post", "/app-yijiu-backstage/upScreenRoom", params);
};
// 视频
// 查询放映厅视频列表
export const getScreenVideoList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getScreenVideoList?token=${localStorage.getItem(
        "logintoken"
      )}&screenRoomName=${params.screenRoomName}&episodes=${params.episodes
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};
// 查询放映厅视频详情
export const getScreenVideoInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getScreenVideoInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加放映厅视频
export const addScreenVideo = params => {
  return req("post", "/app-yijiu-backstage/addScreenVideo", params);
};
// 删除放映厅视频
export const deleteScreenVideo = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteScreenVideo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改放映厅视频
export const upScreenVideo = params => {
  return req("post", "/app-yijiu-backstage/upScreenVideo", params);
};

// 金字塔管理
// 查询金字塔列表
export const getPyramidList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getPyramidList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询金字塔详情
export const getPyramidInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getPyramidInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加金字塔
export const addPyramid = params => {
  return req("post", "/app-yijiu-backstage/addPyramid", params);
};
// 删除金字塔
export const deletePyramid = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deletePyramid?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改金字塔
export const upPyramid = params => {
  return req("post", "/app-yijiu-backstage/upPyramid", params);
};

// 圈层管理
// 查询圈层列表
export const getCirclesList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getCirclesList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};
// 查询圈层详情
export const getCirclesInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getCirclesInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 添加圈层
export const addCircles = params => {
  return req("post", "/app-yijiu-backstage/addCircles", params);
};
// 删除圈层
export const deleteCircles = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteCircles?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改圈层
export const upCircles = params => {
  return req("post", "/app-yijiu-backstage/upCircles", params);
};

// 任务管理
// 查询任务列表
export const getTaskList = params => {
  return req("post", "/app-yijiu-backstage/getTaskList", params);
};
// 查询任务详情
export const getTaskInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getTaskInfo?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 发布任务
export const addTask = params => {
  return req("post", "/app-yijiu-backstage/addTask", params);
};
// 审核任务
export const aduitTask = params => {
  return req("post", "/app-yijiu-backstage/aduitTask", params);
};
// 删除任务
export const deleteTask = params => {
  return axios
    .delete(
      `http://192.168.1.106:446/app-yijiu-backstage/deleteTask?token=${localStorage.getItem(
        "logintoken"
      )}&id=${params.id}`,
      params
    )
    .then(res => res.data);
};
// 修改任务
export const upTask = params => {
  return req("post", "/app-yijiu-backstage/upTask", params);
};

// 任务标签管理
export const getTaskTagList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getTaskTagList?token=${localStorage.getItem(
        "logintoken"
      )}`,
      params
    )
    .then(res => res.data);
};

export const getOrderList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getOrderList?token=${localStorage.getItem(
        "logintoken"
      )}&mobile=${params.mobile}&status=${params.status}&orderNumber=${params.orderNumber
      }&page=${params.page}`,
      params
    )
    .then(res => res.data);
};

export const getAdminBalanceList = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getAdminBalanceList?token=${localStorage.getItem(
        "logintoken"
      )}&userName=${params.userName}&mobile=${params.mobile}&status=${params.status
      }&payWay=${params.payWay}&page=${params.page}`,
      params
    )
    .then(res => res.data);
};

export const getMyBalanceInfo = params => {
  return axios
    .get(
      `http://192.168.1.106:446/app-yijiu-backstage/getUserBalanceList?token=${localStorage.getItem(
        "logintoken"
      )}&type=${params.type}&page=${params.page}&userName=${params.userName
      }&mobile=${params.mobile}`,
      params
    )
    .then(res => res.data);
};

/**
 * 平台协议内容
 **/
export const upPlatformContent = params => {
  return req("post", "/app-yijiu-backstage/upPlatformContent", params);
};


export const getPlatformContentList = params => {
  return req("post", "/app-yijiu-backstage/getPlatformContentList", params);
};
export const upTaskTag = params => {
  return req("post", "/app-yijiu-backstage/upTaskTag", params);
};

/**
 * 订单管理
 **/
export const queryIntegralOrder = params => {
  return req("post", "/app-yijiu-backstage/queryIntegralOrder", params);
};

export const getAdminBillList = params => {
  return req("post", "/app-yijiu-backstage/getAdminBillList", params);
};
export const upAdminBill = params => {
  return req("post", "/app-yijiu-backstage/upAdminBill", params);
};
export const upBillStatus = params => {
  return req("post", "/app-yijiu-backstage/upBillStatus", params);
};

/**
 * 站点管理
 **/
export const getStationList = params => {
  return req("post", "/app-yijiu-backstage/getStationList", params);
};
export const addStation = params => {
  return req("post", "/app-yijiu-backstage/addStation", params);
};
export const deleteStation = params => {
  return req("post", "/app-yijiu-backstage/deleteStation", params);
};
export const upStation = params => {
  return req("post", "/app-yijiu-backstage/upStation", params);
};

/**
 * 用户管理 管理员
 **/
// 用户管理-获取用户列表
export const addUser = params => {
  return req("post", "/app-yijiu-backstage/addUser", params);
};
export const upAdmin = params => {
  return req("post", "/app-yijiu-backstage/upAdmin", params);
};
export const deleteUser = params => {
  return req("post", "/app-yijiu-backstage/deleteUser", params);
};
export const getAdminList = params => {
  return req("post", "/app-yijiu-backstage/getAdminList", params);
};
// 新删除
export const deleteAdmin = params => {
  return req("post", "/app-yijiu-backstage/deleteAdmin", params);
};
// 新添加
export const addAdmin = params => {
  return req("post", "/app-yijiu-backstage/addAdmin", params);
};


// 代练模块---修改
export const setThePriceEdit = params => {
  return req("post", "/app-yijiu-backstage/upAdminHitGameTypeParam", params);
};

/**
 * 资讯分类管理
 **/
export const addNewsClassify = params => {
  return req("post", "/app-yijiu-backstage/addNewsClassify", params);
};
export const upNewsClassify = params => {
  return req("post", "/app-yijiu-backstage/upNewsClassify", params);
};
export const deleteNewsClassify = params => {
  return req("post", "/app-yijiu-backstage/deleteNewsClassify", params);
};
export const getNewsClassifyList = params => {
  return req("post", "/app-yijiu-backstage/getNewsClassifyList", params);
};

/**
 * 资讯分类管理二级
 **/
export const addNewsClassifyTwo = params => {
  return req("post", "/app-yijiu-backstage/addNewsClassifyTwo", params);
};
export const upNewsClassifyTwo = params => {
  return req("post", "/app-yijiu-backstage/upNewsClassifyTwo", params);
};
export const deleteNewsClassifyTwo = params => {
  return req("post", "/app-yijiu-backstage/deleteNewsClassifyTwo", params);
};
export const getNewsClassifyTwoList = params => {
  return req("post", "/app-yijiu-backstage/getNewsClassifyTwoList", params);
};

export const deleteNews = params => {
  return req("get", "/app-yijiu-backstage/deleteNews", params);
};
export const getNewsList = params => {
  return req("get", "/app-yijiu-backstage/getNewsList", params);
};


/**
 * 订单管理
 **/
export const getOrderDetails = params => {
  return req("get", "/app-yijiu-backstage/getOrderDetails", params);
};
export const setOrderRefund = params => {
  return req("get", "/app-yijiu-backstage/setOrderRefund", params);
};
export const getClassifyList = params => {
  return req("post", "/app-yijiu-member/getClassifyList", params);
};

/**
 * 商品管理
 **/
export const getGoodsList = params => {
  return req("get", "/app-yijiu-backstage/getGoodsList", params);
};
export const upGoods = params => {
  return req("get", "/app-yijiu-backstage/upGoods", params);
};

/**
 * 财务管理
 **/
export const getFinanceList = params => {
  return req("get", "/app-yijiu-backstage/getFinanceList", params);
};
export const getWithdrawList = params => {
  return req("get", "/app-yijiu-backstage/getWithdrawList", params);
};
export const setWithdraw = params => {
  return req("get", "/app-yijiu-backstage/setWithdraw", params);
};
export const setServiceCharge = params => {
  return req("get", "/app-yijiu-backstage/setServiceCharge", params);
};
export const getBailBalanceList = params => {
  return req("get", "/app-yijiu-backstage/getBailBalanceList", params);
};
export const refundBailBalance = params => {
  return req("get", "/app-yijiu-backstage/refundBailBalance", params);
};

/**
 * 用户管理
 **/
// 用户管理-获取用户列表
export const userList = params => {
  return req("post", "/api/User/list", params);
};
// 用户管理-保存（添加编辑）
export const userSave = params => {
  return req("post", "/api/User/save", params);
};
// 用户管理-删除用户
export const userDelete = params => {
  return axios
    .delete(
      "/api/User/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};
// 用户管理-重置密码
export const userPwd = params => {
  return req("post", "/api/User/pwd", params);
};
// 用户管理-修改状态
export const userLock = params => {
  return axios.get(
    "/api/User/lock?userId=" +
    params.userId +
    "&lock=" +
    params.lock +
    "&token=" +
    localStorage.getItem("logintoken")
  );
};
// 用户管理-数据权限
export const UserDeptTree = params => {
  return axios.get(
    "/api/UserDept/tree/" +
    params +
    "?token=" +
    localStorage.getItem("logintoken")
  );
};
// 用户管理-数据权限保存
export const UserDeptSave = params => {
  return req("post", "/api/UserDept/save", params);
};
// 用户管理-获取部门设置
export const UserDeptdeptTree = params => {
  return axios.get(
    "/api/UserDept/deptTree/" +
    params +
    "?token=" +
    localStorage.getItem("logintoken")
  );
};
// 用户管理-保存部门设置
export const UserChangeDept = params => {
  return req("post", "/api/User/change/dept", params);
};
// 用户管理-用户下线
export const userExpireToken = params => {
  return req("get", "/api/User/expireToken/" + params, {});
};
// 用户管理-刷新缓存
export const userFlashCache = params => {
  return req("get", "/api/User/flashCache/" + params, {});
};

/**
 * 菜单管理
 **/
// 菜单管理-获取菜单Module/list
export const ModuleList = () => {
  return req("post", "/api/Module/list");
};
// 菜单管理-根据菜单获取数据
export const ModuleGet = params => {
  return axios.get(
    "/api/Module/get/" + params + "?token=" + localStorage.getItem("logintoken")
  );
};
// 菜单管理-获取父级菜单Module/nodes
export const ModuleNodes = params => {
  return req("post", "/api/Module/nodes", params);
};
// 菜单管理-修改菜单
export const ModuleSave = params => {
  return req("post", "/api/Module/save", params);
};
// 菜单管理-删除菜单
export const ModuleDelete = params => {
  return axios
    .delete(
      "/api/Module/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};

/**
 * 角色管理
 **/
// 角色管理-获取角色列表
export const roleList = params => {
  return req("post", "/api/Role/list", params);
};
// 角色管理-保存（添加编辑）
export const roleSave = params => {
  return req("post", "/api/Role/save", params);
};
// 角色管理-删除角色
export const roleDelete = params => {
  return axios
    .delete(
      "/api/Role/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};
// 角色管理-菜单权限（获取）
export const RoleRightTree = params => {
  return axios.get(
    "/api/RoleRight/tree/" +
    params +
    "?token=" +
    localStorage.getItem("logintoken")
  );
};
// 角色管理-菜单权限（保存）
export const RoleRightSave = params => {
  return req("post", "/api/RoleRight/save", params);
};

/**
 * 公司管理
 **/
// 公司管理-获取公司列表
export const deptList = params => {
  return req("post", "/api/Dept/list", params);
};
// 公司管理-保存（添加编辑）
export const deptSave = params => {
  return req("post", "/api/Dept/save", params);
};
// 公司管理-删除公司
export const deptDelete = params => {
  return axios
    .get(
      "/api/Dept/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};
/**
 * 积分
 **/
// 积分管理-查询积分列表
export const integrationList = params => {
  return req("get", "/app-yijiu-backstage/getAdminSignPointList", params);
};
// 积分管理-添加
export const integrationAdd = params => {
  return req("post", "/app-yijiu-backstage/addAdminSignPoint", params);
};
// 积分管理-编辑
export const integrationEdit = params => {
  return req("post", "/app-yijiu-backstage/upAdminSignPoint", params);
};
// 积分管理-删除
export const integrationDelete = params => {
  return req("post", "/app-yijiu-backstage/deleteAdminSignPoint", params);
};
/**
 * 提现
 **/
// 提现-查询提现记录
export const withdrawFundsList = params => {
  return req("post", "/app-yijiu-backstage/payoutsList", params);
};
// 提现-提现
export const withdrawFunds = params => {
  return req("post", "/app-yijiu-backstage/aduitPayout", params);
};
/**
 * 订单
 **/
// 订单-查询订单记录
export const newOrderList = params => {
  return req("get", "/app-yijiu-backstage/getOrderList?orderNum=" + params.orderNum, params);
};

export const refundList = params => {
  return reqGet("get", "/app-yijiu-backstage/getAfterSalesOrderList", params);
};
// 提现-提现
export const refundCheck = params => {
  return req("post", "/app-yijiu-backstage/aduitOrder", params);
};
// 提现-提现
// export const withdrawFunds = params => {
//   return req("post", "/app-yijiu-backstage/aduitPayout", params);
// };
/**
 * 系统环境变量
 **/
// 系统环境变量-获取系统环境变量列表
export const variableList = params => {
  return req("post", "/api/Variable/list", params);
};
// 系统环境变量-保存（添加编辑）
export const variableSave = params => {
  return req("post", "/api/Variable/save", params);
};
// 系统环境变量-删除系统环境变量
export const variableDelete = params => {
  return axios
    .delete(
      "/api/Variable/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};

/**
 * 权限管理
 **/
// 权限管理-获取权限列表
export const permissionList = params => {
  return req("post", "/api/Permission/list", params);
};
// 权限管理-保存权限
export const ermissionSave = params => {
  return req("post", "/api/Permission/save", params);
};
// 权限管理-删除权限
export const ermissionDelete = params => {
  return axios
    .delete(
      "/api/Permission/delete?ids=" +
      params +
      "&token=" +
      localStorage.getItem("logintoken")
    )
    .then(res => res.data);
};
// 权限管理-获取权限
export const roleDropDown = () => {
  return axios
    .get("/api/Role/dropDown/all?&token=" + localStorage.getItem("logintoken"))
    .then(res => res.data);
};
// 权限管理-配置权限
export const RolePermission = params => {
  return req("post", "/api/RolePermission/save", params);
};



// WEBPACK FOOTER //
// ./src/api/userMG.js